import Cards from "../components/Cards"
import Icons from "../components/Icons"
import "../sass/layout/projects.sass"

const Projects = () => {
    
    return (
        <div className="home projects">
            <Cards/>
            <Icons />
        </div>
    )
}

export default Projects